import React, { createContext, useContext, useState, useEffect } from 'react';
import { Ability } from '@casl/ability';
import { defineAbilitiesFor } from './abilities';

const AbilityContext = createContext(undefined);

export const AbilityProvider = ({ children }) => {
    const [ability, setAbility] = useState(new Ability([]));

    useEffect(() => {
        // Load permissions from local storage on mount
        const storedPermissions = localStorage.getItem('rolePermissions');
        if (storedPermissions) {
            setRolePermissions(JSON.parse(storedPermissions));
        }
    }, []);

    const setRolePermissions = (rolePermissions) => {
        const newAbility = new Ability(defineAbilitiesFor(rolePermissions));
        setAbility(newAbility);
        localStorage.setItem('rolePermissions', JSON.stringify(rolePermissions)); // Save to local storage
    };

    const clearRolePermissions = () => {
        setAbility(new Ability([]));
        localStorage.removeItem('rolePermissions'); // Clear from local storage
    };

    return (
        <AbilityContext.Provider value={{ ability, setRolePermissions, clearRolePermissions }}>
            {children}
        </AbilityContext.Provider>
    );
};

export const useAbility = () => {
    const context = useContext(AbilityContext);
    if (!context) {
        throw new Error("useAbility must be used within an AbilityProvider");
    }
    return context;
};
